import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StringUtilService {

  private locale = 'en-CA';

  private dateOpts: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  };

  private dateTimeOpts: Intl.DateTimeFormatOptions = {
    ...this.dateOpts,
    hour: '2-digit',
    minute: '2-digit'
  };

  constructor() { }

  encode(source: string): string {
    return encodeURIComponent(source);
  }

  decode(source: string): string {
    return decodeURIComponent(source);
  }

  formatDate(unixTimestamp): string {
    return Intl.DateTimeFormat(this.locale, this.dateOpts).format(new Date(unixTimestamp));
  }

  formatDateTime(unixTimestamp): string {
    return Intl.DateTimeFormat(this.locale, this.dateTimeOpts).format(new Date(unixTimestamp));
  }
}
